const ICONS_MAP = {
  EDUCATION: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/icon-education.png`,
  PAYMENT: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/icon-payment.png`,
  HEALTHCARE: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/icon-healthcare.png`,
  RESOURCE_MANAGEMENT: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/icon-resource-management.png`,
  E_GOVERNANCE: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/icon-e-governance.png`,
};

export const OUR_DOMAIN_EXPERTISE: Array<{
  id: number;
  title: string;
  description: string;
  icon: string;
  caseStudyLink?: string;
}> = [
  {
    id: 1,
    title: "Education",
    description:
      "Empowering educational institutions with tailored SaaS solutions, driving transformative change from administrative efficiency to enhanced student engagement.",
    icon: ICONS_MAP.EDUCATION,
    caseStudyLink: "/case-studies/qfix-online-integrated-payment-and-billing-service",
  },
  {
    id: 2,
    title: "Payment",
    description:
      "Experience faster rollouts, enhanced efficiency, and a path to payment innovation.",
    icon: ICONS_MAP.PAYMENT,
    caseStudyLink: "/case-studies/pinelabs-financing-transactions-management-software",
  },
  {
    id: 3,
    title: "Healthcare",
    description:
      "Supports 1,000's of service user with 1+ million data transaction daily",
    icon: ICONS_MAP.HEALTHCARE,
    caseStudyLink: "/case-studies/pinelabs-financing-transactions-management-software",
  },
  {
    id: 4,
    title: "Resource Management",
    description:
      "Build product suite for waste movements, bulk haulage, people and property management",
    icon: ICONS_MAP.RESOURCE_MANAGEMENT,
    caseStudyLink: "/case-studies/fissara-mobile-workforce-management-software",
  },
  {
    id: 5,
    title: "e-Governance",
    description:
      "Build Citizen friendly smart city solutions for state government and municipal corporations",
    icon: ICONS_MAP.E_GOVERNANCE,
    caseStudyLink: "/case-studies/pathlock-platform-for-company-auditing",
  },
];
